import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header.component';
import { MatMenuModule } from '@angular/material/menu';
@NgModule({
    imports: [ RouterModule, CommonModule ],
    declarations: [ HeaderComponent ],
    exports: [ HeaderComponent,MatMenuModule ]
})

export class HeaderModule {}